var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"privacy-withdrawall__info"},[_vm._v("\n    * "+_vm._s(_vm.$t('You can at any time withdraw your consent to the processing of personal data by ' +
        'accessing your client account. Withdrawal of the agreement will not affect the lawfulness of ' +
        'the data processing carried out until the agreement is withdrawn'))+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20383e1e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/modules/shared/components/PrivacyConsentWithdrawalInfo.vue
// module id = 2524
// module chunks = 0